import type { ReactNode } from 'react'
import { cx } from './utils/cx'

export type TimeVariant = 'ok' | 'warn' | 'hot' | 'done'

export function TimeChip({
  variant = 'ok',
  children,
  className
}: {
  variant?: TimeVariant
  children?: ReactNode
  className?: string
}) {
  return <span className={cx('st-timechip', variant, className)}>{children}</span>
}
